'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _composeWithScope = require('recompose-scope/composeWithScope');

var _composeWithScope2 = _interopRequireDefault(_composeWithScope);

var _injectProps = require('recompose-scope/injectProps');

var _injectProps2 = _interopRequireDefault(_injectProps);

var _exposeProps = require('recompose-scope/exposeProps');

var _exposeProps2 = _interopRequireDefault(_exposeProps);

var _withProps = require('recompose/withProps');

var _withProps2 = _interopRequireDefault(_withProps);

var _setWrappedDisplayName = require('coact-utils/setWrappedDisplayName');

var _setWrappedDisplayName2 = _interopRequireDefault(_setWrappedDisplayName);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function dateEditingFormatter(value) {
  if (!value) return '';
  return (0, _moment2.default)(value).format('YYYYMMDD');
}

var string = _propTypes2.default.string,
    func = _propTypes2.default.func;

var enhancer = (0, _composeWithScope2.default)((0, _injectProps2.default)({
  type: string,
  format: string,
  formatterWhenFocused: func
}), (0, _withProps2.default)(function (_ref) {
  var type = _ref.type,
      format = _ref.format,
      formatterWhenFocused = _ref.formatterWhenFocused;

  if (type === 'date') {
    return {
      format: format || 'YYYY-MM-DD',
      formatterWhenFocused: formatterWhenFocused || dateEditingFormatter
    };
  }
  return {};
}), (0, _exposeProps2.default)(['format', 'formatterWhenFocused']));

exports.default = (0, _setWrappedDisplayName2.default)(enhancer, 'defaultPropsByType');


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/inputs/Input/defaultPropsByType.js
// module id = 1733
// module chunks = 0